import random from 'random-seed'

import standardMessages from '../../messages.json'

export default function generateGlobalPerformanceMessage(
	playerId: string,
	gameId: number | string
): string {
	const messages = standardMessages.globalPerformance
	const rng = random(`${playerId}${gameId}-globalPerformance`)
	return messages[rng(messages.length)]
}
